"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var validatedViewModel_1 = require("./base/validatedViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.email = ko.observable().extend({
            required: true,
            email: true
        });
        if (options.email) {
            this.email(options.email);
        }
        setTimeout(function () {
            _this.initValidation();
        }, 0);
    }
    ViewModel.prototype.submit = function () {
        if (this.validation !== undefined && !this.validation.isValid()) {
            this.validation.errors.showAllMessages();
            return false;
        }
        ;
        return true;
    };
    return ViewModel;
}(validatedViewModel_1.default));
;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=accountRecovery.js.map